import React, {Component} from "react";
import store from "../store.js";
import {connect} from "react-redux";
import { AlertList } from "react-bs-notifier";

class Alerts extends Component {

    render() {
        return (
            <AlertList timeout={4000} showIcon={false} onDismiss={(e) => {
                store.dispatch({
                    type: 'removeAlert',
                    value: e
                })
            }} alerts={this.props.alerts.map((a) => {
                return {
                    id: a.id,
                    type: a.type,
                    message: a.content,
                    headline: a.title
                };
            })} />
        );
    }
}
let mapStateToProps = (state) => {
    return {
        alerts: state.alerts
    };
};
export default connect(mapStateToProps)(Alerts);



// WEBPACK FOOTER //
// ./src/componentsBody/Alerts.js